/* global angular */

angular.module('UploadingDataserviceCmp', [])
  .factory('isUploadingDataservice', isUploadingDataservice)

isUploadingDataservice.$inject = []

function isUploadingDataservice () {
  var isUploading = {}
  return {
    set: function (key) {
      isUploading[key] = true
    },
    reset: function (key) {
      isUploading[key] = false
    },
    isAnyUploading: function () {
      return !!Object.keys(isUploading).filter(function (item) {
        return isUploading[item]
      }).length
    }
  }
}
